<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('employee_day_shift')">
            <button
                :disabled="!selectedUserIds.length"
                class="btn btn-success mr-1"
                @click="openBulkConfirmModal"
            >
                {{ $t('confirm') }}
            </button>

            <app-default-button
                v-if="$can('view_all_day_shifts')"
                :url="'/day-shift'"
                :title="$t('day_shift')"
                btn-class="btn btn-primary mr-1"
            />
            
            <app-default-button
                v-if="this.$can('update_attendance_status')"
                :title="$t('add_employee_schedule')"
                @click="openModalAddMultiple"
                btn-class="btn btn-primary mr-1"
            />
            <app-default-button
                v-if="$can('view_all_day_shifts')"
                :title="$t('export')"
                @click="exportDayShift"
                btn-class="btn btn-success"
            />
        </app-page-top-section>

        <app-filter-with-search
            :key="'employee-day-shift-filter-' + filterStateVersion"
            :options="options"
            :search-value="searchValue"
            :filter-state-version="filterStateVersion"
            @filteredValue="setFilterValues"
            @searchValue="setSearchValue"
        />

<!--        <app-attendance-create-edit-modal-->
<!--            v-if="isAttendanceModalActive"-->
<!--            v-model="isAttendanceModalActive"-->
<!--        />-->

        <employee-day-shift-create-multiple-modal
            v-if="isModalAddMultipleActive"
            v-model="isModalAddMultipleActive"
            :selected-users="selectedUserIds"
            @createMultipleSuccess="updateEmployeeDayShiftSuccess"
        />

        <app-employee-day-shift-create-edit-modal
            v-if="isAttendanceModalActive"
            v-model="isAttendanceModalActive"
            :selected-column="selectedColumn"
            :selected-url="selectedUrl"
            @updateSuccess="updateEmployeeDayShiftSuccess"
        />

        <app-confirmation-modal
            v-if="isApprovalModalActive"
            icon="settings"
            :message="$t('approve_this_work_shift')"
            modal-id="app-approval-modal"
            @confirmed="confirmApproval"
            @cancelled="cancelConfirmApproval"
        />

        <app-confirmation-modal
            v-if="isConfirmationModalActive"
            :icon="confirmationIcon"
            :title="confirmationTitle"
            modal-id="app-confirmation-modal"
            @confirmed="handleConfirmation"
            @cancelled="cancelled"
        />

        <div class="card card-with-shadow border-0 card-min-height" id="employee-day-shift-table">
            <div class="card-body">
                <div class="summery-calendar">
                    <!-- <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between mb-primary"> -->
                        <!-- <app-month-calendar :show-date-range-calendar="true"/> -->
                        <!-- <app-period-calendar :filters="filters"/> -->
                        <!-- <app-period-calendar /> -->
                    <!-- </div> -->

                    <app-overlay-loader v-if="loading"/>

                    <div class="d-flex table-scroll-wrapper custom-scrollbar custom-scrollbar-with-mouse-move" v-else-if="$optional(attendances, 'data', 'length')">
                        <div class="profile-column flex-shrink-0">
                            <div class="column-header d-flex align-items-center px-1">
                                <div class="ml-2 mr-1" style="width: 24px" v-if="$can('update_attendance_status')"></div>
                                <div class="custom-control custom-checkbox ml-1">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           id="select-all-employees"
                                           :checked="isAllSelected"
                                           @change="toggleSelectAll">
                                    <label class="custom-control-label cursor-pointer" for="select-all-employees"></label>
                                </div>
                                <span class="ml-3">{{ $t('profile') }}</span>
                            </div>
                            <draggable
                                :list="attendances.data"
                                :forceFallback="true"
                                handle=".drag-handle"
                                v-bind="dragOptions"
                                @end="onDragEnd"
                            >
                                <div class="d-flex align-items-center row-height border-bottom border-right overflow-hidden" 
                                     v-for="employee in attendances.data"
                                     :key="employee.id">
                                        <div class="drag-handle cursor-grab ml-2 mr-1 text-muted" v-if="$can('update_attendance_status')">
                                            <app-icon name="menu" size="16"/>
                                        </div>
                                        <div class="custom-control custom-checkbox ml-1">
                                            <input type="checkbox"
                                                   class="custom-control-input"
                                                   :id="`employee-${employee.id}`"
                                                   :value="employee.id"
                                                   v-model="selectedUserIds">
                                            <label class="custom-control-label cursor-pointer" :for="`employee-${employee.id}`"></label>
                                        </div>
                                        <app-employee-profile-card-horizontal :employee="employee" :employee-action-btn="getEmployeeActionBtn(employee)" class="flex-grow-1"/>
                                </div>
                            </draggable>
                            
                            <div class="summary-row-wrapper">
                                <div v-for="shift in allDayShifts" :key="shift.id" class="d-flex align-items-center row-height border-bottom border-right summary-row">
                                    <div class="ml-2 mr-1" style="width: 24px; visibility: hidden" v-if="$can('update_attendance_status')"></div>
                                    <div class="custom-control custom-checkbox ml-1" style="visibility: hidden">
                                        <input type="checkbox" class="custom-control-input">
                                        <label class="custom-control-label"></label>
                                    </div>
                                    <div class="d-flex align-items-center px-1 flex-grow-1">
                                        <div class="shift-color-circle mr-2" :style="{ backgroundColor: shift.color }"></div>
                                        {{ shift.name }}
                                    </div>
                                </div>

                                <!-- Total Hours Label -->
                                 <div class="d-flex align-items-center justify-content-center px-3 row-height border-bottom border-right summary-row font-weight-bold">
                                    {{ $t('total_hours') }}
                                 </div>
                            </div>
                        </div>
                        <div class="date-column">
                            <div class="d-flex">
                                <div class="date-value-wrapper" v-for="range in ranges">
                                    <div class="date">
                                        {{ formatTitleRangeDate(range) }}
                                    </div>
                                    <div
                                        class="date-hour-wrapper justify-content-start row-height"
                                        v-for="(employee, index) in attendances.data"
                                        :key="`cell-${employee.id}-${range.format('YYYY-MM-DD')}`"
                                    >
                                        <div class="flex-grow-1 text-center cursor-pointer h-100" @click="handleCellClick(employee, range)">
                                            <template v-if="getEmployeeDayShift(employee, range)">
                                                <div class="date-hour h-100" 
                                                     :style="getShiftStyles(getEmployeeDayShift(employee, range))">
                                                    
                                                    <div class="time-content">
                                                        <template v-if="getEmployeeDayShift(employee, range).is_holiday == 1">
                                                            {{ $t('holiday') }}
                                                        </template>
                                                        <template v-else>
                                                            <span class="hour">{{ getEmployeeDayShift(employee, range).start_at ? getEmployeeDayShift(employee, range).start_at.slice(0, 5) : '' }}</span>
                                                            -
                                                            <span class="hour">{{ getEmployeeDayShift(employee, range).end_at ? getEmployeeDayShift(employee, range).end_at.slice(0, 5) : '' }}</span>
                                                        </template>
                                                    </div>

                                                    <div v-if="getEmployeeDayShift(employee, range).pivot.description" 
                                                         class="note-icon" 
                                                         :title="getEmployeeDayShift(employee, range).pivot.description">
                                                        <app-icon name="file-text" size="15"/>
                                                    </div>
                                                    <div v-else class="note-display text-center">-</div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="date-hour date-hour--empty h-100">
                                                    <div class="add-shift-icon">
                                                        <app-icon name="plus-circle" class="text-danger" size="20"/>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <div class="date-hour-wrapper justify-content-start row-height"
                                         v-for="shift in allDayShifts"
                                         :key="`summary-${shift.id}-${range.format('YYYY-MM-DD')}`">
                                         <div class="flex-grow-1 text-center h-100 d-flex align-items-center justify-content-center summary-row">
                                            {{ getShiftCount(shift.id, range) }}
                                         </div>
                                    </div>
                                    
                                    <!-- Total Hours Cell -->
                                    <div class="date-hour-wrapper justify-content-center row-height">
                                        <div class="flex-grow-1 text-center h-100 d-flex align-items-center justify-content-center summary-row font-weight-bold">
                                           {{ getTotalHours(range) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-empty-data-block v-else :message="$t('nothing_to_show_here')"/>
                    <div class="d-flex flex-column flex-md-row justify-content-between mt-primary" v-if="attendances.total">
                        <!-- Pagination options dropdown -->
                        <div v-if="attendances.total > 10" class="dropdown-menu-filter d-flex align-items-center justify-content-center justify-content-md-start">
                            <div class="dropdown keep-inside-clicks-open">
                                <button
                                    class="btn btn-filter"
                                    type="button"
                                    id="show-pagination-employee-day-shift"
                                    data-toggle="dropdown">
                                    {{ perPage }}
                                    <app-icon name="chevron-down" class="size-16 ml-1"/>
                                </button>
                                <div class="my-2 dropdown-menu dropdown-menu-employee-day-shift"
                                     aria-labelledby="show-pagination-employee-day-shift">
                                    <a v-for="(item, index) in paginationOptions"
                                       :key="index" href="#"
                                       :class="{'active disabled': item === perPage}"
                                       @click.prevent="setPerPage(item)"
                                       class="dropdown-item">
                                        {{ item }}
                                    </a>
                                </div>
                            </div>
                            <label class="text-muted ml-2 mb-0">{{ $t('items_showing_per_page') }}</label>
                        </div>
                        <div v-else></div>

                        <app-pagination
                            v-if="attendances.last_page > 1"
                            :rowLimit="attendances.per_page"
                            :totalRow="attendances.total"
                            :maxPage="attendances.last_page"
                            @submit="setPagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="floating-button-wrapper">
            <button class="btn btn-primary btn-floating" @click="openReportModal">
                <app-icon name="pie-chart" />
            </button>
        </div>

        <employee-day-shift-report-modal
            v-if="isReportModalActive"
            v-model="isReportModalActive"
            :attendances="attendances"
            :all-day-shifts="allDayShifts"
        />
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import AppEmployeeProfileCardHorizontal from "../../Attendance/Component/AppEmployeeProfileCardHorizontal.vue";
import AppAttendanceTopButtons from "../../Attendance/Component/AppAttendanceTopButtons";
import {
  DepartmentFilterMixin,
  DesignationFilterMixin,
  EmploymentStatusFilterMixin,
  WorkingShiftFilterMixin
} from "../../../Mixins/FilterMixin";
import MemoizeMixins from "../../../../../common/Helper/Support/MemoizeMixins";
import AttendanceHelperMixin from "../../../Mixins/AttendanceHelperMixin";
import { ATTENDANCES, EMPLOYEE_DAY_SHIFT, DAY_SHIFT } from "../../../../Config/ApiUrl";
import { serverDateFormat, serverDateTimeFormat } from "../../../../../common/Helper/Support/DateTimeHelper";
import moment from "moment";
import TemplateHelper from "../../../../../core/helpers/template-helper/TemplateHelper";
import { axiosDelete, axiosGet, axiosPost, axiosPatch } from "../../../../../common/Helper/AxiosHelper";
import {getDateRange} from "../../../../../common/Helper/Support/DateTimeHelper";
import {objectToQueryString} from "../../../../../common/Helper/Support/TextHelper";
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import DayShiftUserMixin from "../../../Mixins/DayShiftUserMixin";
import EmployeeDayShiftCreateMultipleModal from "../../Attendance/Component/EmployeeDayShiftCreateMultipleModal.vue";
import EmployeeDayShiftReportModal from "./EmployeeDayShiftReportModal.vue";


export default {
    name      : "AttendanceDetails",
    components: {
        draggable,
        EmployeeDayShiftCreateMultipleModal,
        EmployeeDayShiftReportModal,
        AppEmployeeProfileCardHorizontal,
        AppAttendanceTopButtons
    },
    mixins    : [
        DepartmentFilterMixin, DesignationFilterMixin, EmploymentStatusFilterMixin, HelperMixin,
        WorkingShiftFilterMixin, MemoizeMixins, AttendanceHelperMixin, DayShiftUserMixin,
    ],
    data() {
        this.reorderProcessing = false;
        return {
            filters: [{
                id   : 'thisMonth',
                value: this.$t('this_month')
            }],
            isAttendanceModalActive: false,
            isConfirmationModalActive: false,
            isModalAddMultipleActive: false,
            isApprovalModalActive: false,
            selectedRow: null,
            selectedColumn: {},
            selectedUrl: null,
            isReportModalActive: false,
            allDayShifts: [],
            perPage: 10,
            paginationOptions: [10, 20, 30, 40, 50, 100],
            shiftSummary: [],
            selectedUserIds: [],
            confirmationAction: 'delete',
            confirmationTitle: '',
            confirmationIcon: 'trash-2',
            filterStateVersion: 0,
            historySyncMode: 'replace',
            searchValue: '',
            stateHydrated: false,
        }
    },
    created() {
        this.getAllDayShifts();
        this.hydrateFromUrl();
    },
    methods   : {
        parseQueryValue(rawValue) {
            if ([null, undefined, ''].includes(rawValue)) {
                return null;
            }

            try {
                return JSON.parse(rawValue);
            } catch (e) {
                return rawValue;
            }
        },
        applyFilterActiveState(filterKey, value) {
            const index = this.options.filters.findIndex(filter => filter.key === filterKey);

            if (index > -1) {
                this.$set(this.options.filters[index], 'active', value);
            }
        },
        defaultTimeRangePayload(filter = 'thisMonth') {
            const range = getDateRange(filter);
            const month = range[0];

            return {
                within: filter,
                month: month.format('MMM'),
                month_number: month.format('M') - 1,
                year: month.format('YYYY'),
                time_range: {
                    start: range[0].format(serverDateFormat),
                    end: range[range.length - 1].format(serverDateFormat),
                    value: filter,
                }
            };
        },
        hydrateFromUrl() {
            const query = new URLSearchParams(window.location.search);
            this.stateHydrated = false;

            this.$store.dispatch('clearFilterObject');

            const payload = {};
            query.forEach((rawValue, key) => {
                payload[key] = this.parseQueryValue(rawValue);
            });

            const parsedPerPage = Number(payload.per_page || 0);
            this.perPage = parsedPerPage > 0 ? parsedPerPage : 10;

            const hasDateState = payload.time_range || payload.within || payload.month || payload.month_number || payload.year;
            if (!hasDateState) {
                Object.assign(payload, this.defaultTimeRangePayload());
            }

            if (Object.keys(payload).length) {
                this.$store.dispatch('updateFilterObject', payload);
            } else {
                this.setDefaultFilter();
            }

            this.searchValue = payload.search || '';
            this.applyFilterActiveState('departments', payload.departments || undefined);
            this.applyFilterActiveState('users', payload.users || undefined);
            this.applyFilterActiveState('employment_statuses', payload.employment_statuses || undefined);
            this.applyFilterActiveState('employee_tags', payload.employee_tags || undefined);
            this.applyFilterActiveState('time_range', payload.time_range || undefined);

            this.filterStateVersion += 1;
            this.stateHydrated = true;

            this.$nextTick(() => {
                this.$hub.$emit('resetPaginationState', Number(payload.page || 1));
                if (this.queryString) {
                    this.syncUrlFromFilterState();
                    this.getAttendances(this.queryString);
                }
            });
        },
        syncUrlFromFilterState() {
            if (this.historySyncMode === 'none') {
                this.historySyncMode = 'replace';
                return;
            }

            const query = objectToQueryString({
                ...(this.filterQuery || {}),
                ...(this.perPage !== 10 ? {per_page: this.perPage} : {})
            });
            const url = new URL(window.location.href);

            url.search = '';

            if (query) {
                const params = new URLSearchParams(query);
                params.forEach((value, key) => {
                    url.searchParams.set(key, value);
                });
            }

            if (this.historySyncMode === 'push') {
                window.history.pushState({}, '', url);
            } else {
                window.history.replaceState({}, '', url);
            }

            this.historySyncMode = 'replace';
        },
        handleBrowserNavigation() {
            this.historySyncMode = 'none';
            this.hydrateFromUrl();
        },
        setFilterValues(filterValue) {
            this.historySyncMode = 'push';
            this.$store.dispatch('updateFilterObject', {
                ...filterValue,
                page: 1,
            });
            this.$hub.$emit('resetPaginationState', 1);
        },
        setSearchValue(search) {
            this.searchValue = search;
            this.historySyncMode = 'push';
            this.$store.dispatch('updateFilterObject', {
                search,
                page: 1,
            });
            this.$hub.$emit('resetPaginationState', 1);
        },
        setDefaultFilter() {
            this.$store.dispatch('updateFilterObject', {
                page: 1,
                ...this.defaultTimeRangePayload(),
            });
        },
        getShiftCount(dayShiftId, range) {
            if (!this.shiftSummary) return 0;
            const dateStr = range.format(serverDateFormat);
            const summary = this.shiftSummary.find(s => s.day_shift_id === dayShiftId && s.date === dateStr);
            return summary ? summary.count : 0;
        },
        getTotalHours(range) {
            let totalDuration = 0;
            const dateStr = range.format(serverDateFormat);

            this.allDayShifts.forEach(shift => {
                 // Get count for this shift on this day
                const summary = this.shiftSummary.find(s => s.day_shift_id === shift.id && s.date === dateStr);
                const count = summary ? summary.count : 0;

                if (count > 0 && shift.start_at && shift.end_at) {
                    const start = moment(shift.start_at, 'HH:mm:ss');
                    const end = moment(shift.end_at, 'HH:mm:ss');
                    
                    // Handle overnight shifts
                    if (end.isBefore(start)) {
                        end.add(1, 'day');
                    }
                    
                    const duration = end.diff(start);
                    totalDuration += (duration * count);
                }
            });

            const durationObj = moment.duration(totalDuration);
            const hours = Math.floor(durationObj.asHours());
            const mins = durationObj.minutes();
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        },
        handleCellClick(employee, range) {
            const employeeDayShift = this.getEmployeeDayShift(employee, range);
            this.selectedRow = employee;
            
            if (!employeeDayShift) {
                // No shift exists - open Add modal
                this.selectedColumn = {
                    user_id: employee.id,
                    date: range.format(serverDateFormat),
                };
                this.selectedUrl = null;
                this.openModalAdd();
            } else {
                // Shift exists - open Edit modal
                this.selectedColumn = {};
                const user_id = employeeDayShift.pivot.user_id;
                const day_shift_id = employeeDayShift.pivot.day_shift_id;
                const date = employeeDayShift.pivot.date;
                this.selectedUrl = `${EMPLOYEE_DAY_SHIFT}?user_id=${user_id}&day_shift_id=${day_shift_id}&date=${date}`;
                this.openModalEdit();
            }
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.selectedUserIds = [];
            } else {
                this.selectedUserIds = this.attendances.data.map(user => user.id);
            }
        },
        openBulkConfirmModal() {
            this.confirmationAction = 'bulk-approve';
            this.confirmationTitle = this.$t('are_you_sure');
            this.confirmationIcon = 'check-circle';
            this.isConfirmationModalActive = true;
        },
        handleConfirmation() {
            if (this.confirmationAction === 'delete') {
                this.confirmDelete();
            } else if (this.confirmationAction === 'bulk-approve') {
                this.executeBulkApproval();
            }
        },
        executeBulkApproval() {
             if (!this.ranges || this.ranges.length === 0) {
                this.$toastr.e('', this.$t('no_date_range_selected'));
                this.isConfirmationModalActive = false;
                return;
            }
            
            const startDate = this.ranges[0].format('YYYY-MM-DD');
            const endDate = this.ranges[this.ranges.length - 1].format('YYYY-MM-DD');
            
            const data = {
                user_ids: this.selectedUserIds,
                start_date: startDate,
                end_date: endDate,
            };

            axiosPost(`${EMPLOYEE_DAY_SHIFT}/approve`, data).then(response => {
                this.$toastr.s('', response.data.message);
                this.selectedUserIds = [];
                this.isConfirmationModalActive = false;
                this.getAttendances(this.queryString);
            }).catch((error) => {
                if (error.message)
                  this.toastException(error);
                this.isConfirmationModalActive = false;
            });
        },
        openModalDelete() {
            this.confirmationAction = 'delete';
            this.confirmationTitle = this.$t('are_you_sure');
            this.confirmationIcon = 'trash-2';
            this.isConfirmationModalActive = true;
        },
        openModalEdit() {
            this.isAttendanceModalActive = true;
        },
        openModalAdd() {
            this.isAttendanceModalActive = true;
        },
        openModalAddMultiple() {
            this.isModalAddMultipleActive = true;
        },
        getAttendances(queryString) {
            this.loading = true;
            this.selectedUserIds = [];
            const separator = queryString ? '&' : '';
            const url = `${ATTENDANCES}/day-shift-details?${queryString}${separator}per_page=${this.perPage}&day_shift_order=1`;
            axiosGet(url).then(response => {
                this.attendances         = response.data.attendances;
                this.ranges              = response.data.range.map(range => moment(range, serverDateTimeFormat));
                this.shiftSummary        = response.data.shift_summary;
            }).finally(() => {
                this.loading = false;
                TemplateHelper.moveHorizontalScrollbarWithMouse();
            })
        },
        getShiftStyles(employeeDayShift) {
            const isApproved = employeeDayShift.pivot.status === 1;
            const borderStyle = isApproved ? 'solid' : 'dashed';
            const borderColor = isApproved ? '#1e90ff' : '#989898';
            
            return {
                border: `2px ${borderStyle} ${borderColor}`,
                color: borderColor
            };
        },
        getEmployeeDayShift(employee, date) {
            // return this.memoize(`attendance-${employee.id}-${date.format(serverDateFormat)}`, () => {
                return employee.day_shifts.find(day_shift => {
                    return day_shift.pivot.date === date.format(serverDateFormat);
                });
            // });
        },
        formatTitleRangeDate(range) {
            let date = range.locale(window.appLanguage)
            return date.format('D (dddd)')
        },
        cancelled() {
            this.isConfirmationModalActive = false;
        },
        confirmDelete() {
            return axiosDelete(`${EMPLOYEE_DAY_SHIFT}?id=${this.selectedColumn.pivot.id}`).then(response => {
                this.$toastr.s('', response.data.message);
                this.isConfirmationModalActive = false;
                this.getAttendances(this.queryString);
            }).catch((error) => {
                if (error.message)
                    this.toastException(error);
            });
        },
        confirmApproval() {
            if (!this.ranges || this.ranges.length === 0) {
                this.$toastr.e('', this.$t('no_date_range_selected'));
                this.isApprovalModalActive = false;
                return;
            }
            
            const startDate = this.ranges[0].format('YYYY-MM-DD');
            const endDate = this.ranges[this.ranges.length - 1].format('YYYY-MM-DD');
            
            const data = {
                user_id: this.selectedRow?.id,
                start_date: startDate,
                end_date: endDate,
            };

            return axiosPost(`${EMPLOYEE_DAY_SHIFT}/approve`, data).then(response => {
                this.$toastr.s('', response.data.message);
                this.isApprovalModalActive = false;
                this.getAttendances(this.queryString);
            }).catch((error) => {
                if (error.message)
                  this.toastException(error);
            });
        },
        cancelConfirmApproval() {
            this.isApprovalModalActive = false;
        },
        updateEmployeeDayShiftSuccess() {
            this.getAttendances(this.queryString);
        },
        getEmployeeActionBtn(employeeData) {
            return {
                show: true,
                title: this.$t('status_approve'),
                class: 'btn-success',
                action: () => {
                    this.isApprovalModalActive = true;
                    this.selectedRow = employeeData;
                }
            };
        },
        exportDayShift() {
            const lang = window.appLanguage || 'en';
            window.location.href = `${EMPLOYEE_DAY_SHIFT}/export?${this.queryString}&lang=${lang}`;
        },
        openReportModal() {
            this.isReportModalActive = true;
        },
        getAllDayShifts() {
            axiosGet(DAY_SHIFT).then(response => {
                this.allDayShifts = response.data.data;
            });
        },
        onDragEnd() {
            if (this.reorderProcessing) return;

            const offset = ((this.attendances.current_page || 1) - 1) * this.perPage;
            const highestDisplayOrder = Math.max((this.attendances.total || 0) - offset, 0);
            const orders = this.attendances.data.map((employee, index) => ({
                id: employee.id,
                display_order: highestDisplayOrder - index
            }));

            this.reorderProcessing = true;
            axiosPatch(`${EMPLOYEE_DAY_SHIFT}/reorder`, { orders })
                .then(({ data }) => {
                    this.$toastr.s(data.message);
                })
                .catch(error => {
                    if (error.response) {
                        this.toastException(error.response.data);
                    }
                    this.getAttendances(this.queryString);
                })
                .finally(() => {
                    this.reorderProcessing = false;
                });
        },
        setPerPage(value) {
            if (Number(this.perPage) === Number(value)) {
                return;
            }

            this.historySyncMode = 'push';
            this.perPage = value;
            this.$store.dispatch('updateFilterObject', {
                page: 1,
            });
            this.$hub.$emit('resetPaginationState', 1);
            $('.dropdown-menu-employee-day-shift').removeClass('show');
        },
        setPagination(page) {
            this.historySyncMode = 'push';
            this.$store.dispatch('updateFilterObject', {page});
        },
    },
    mounted() {
        window.addEventListener('popstate', this.handleBrowserNavigation);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.handleBrowserNavigation);
    },
    watch     : {
        queryStateSignature: {
            handler  : function () {
                if (!this.stateHydrated || !this.queryString) {
                    return;
                }

                this.syncUrlFromFilterState();
                this.getAttendances(this.queryString)
            }
        }
    },
    computed: {
        isAllSelected() {
            if (!this.attendances || !this.attendances.data || this.attendances.data.length === 0) {
                return false;
            }
            return this.attendances.data.length === this.selectedUserIds.length;
        },
        dragOptions() {
            return {
                animation: 300,
                disabled: !this.$can('update_attendance_status'),
            };
        },
        queryStateSignature() {
            return `${this.queryString}::${this.perPage}`;
        },
    }
}
</script>

<style lang="scss" scoped>
    .card-min-height {
        min-height: 400px;
    }

    .row-height {
        height: 50px !important;
    }

    .date-value-wrapper {
        width: 116px;
        flex-shrink: 0;
    }

    .date-hour-wrapper {
        position: relative;
        padding: 4px 4px;
    }

    ::v-deep .date-hour {
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        padding: 0 16px;
        
        .hour {
            min-height: calc(0.935rem * 1.5);
        }
        
        &--empty {
            border-bottom: none !important;
            background-color: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
        }
    }

    ::v-deep .add-shift-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.2s ease;
        
        &:hover {
            transform: scale(1.1);
        }
        
        svg {
            opacity: 0.7;
            transition: opacity 0.2s ease;
        }
        
        &:hover svg {
            opacity: 1;
        }
    }

    ::v-deep .time-content {
        white-space: nowrap;
        line-height: 1;
        width: 92px;
    }

    ::v-deep .note-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        
        svg {
            opacity: 0.7;
            transition: opacity 0.2s ease;
        }
        
        &:hover svg {
            opacity: 1;
        }
    }

    ::v-deep .note-display {
        font-size: 0.75rem;
        opacity: 0.85;
    }

    .column-header, .date {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .table-scroll-wrapper {
        overflow: auto;
        max-height: calc(100vh - 250px);
        position: relative;
    }

    .profile-column {
        position: sticky;
        left: 0;
        z-index: 3;
        background-color: #fff;
    }

    .profile-box {
        border-bottom: none !important;
    }

    .date-column {
        overflow: visible !important;
    }

    .floating-button-wrapper {
        position: fixed;
        bottom: 30px;
        right: 30px;
    }

    .btn-floating {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        padding: 0;
        
        svg {
            width: 24px;
            height: 24px;
        }
    }

    .summary-row-wrapper {
        margin-left: -1px;
        border-left: 1px solid rgb(249, 249, 249);
    }

    .summary-row {
        font-weight: 400;
        background: #fff;
        font-size: 0.82rem;
        line-height: 1.1;
    }

    .shift-color-circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .drag-handle {
        cursor: grab;
        user-select: none;
        display: flex;
        align-items: center;
        padding: 4px;
        
        &:active {
            cursor: grabbing;
        }
    }
</style>
